import React from 'react';
import styled from 'styled-components';
import ParticipantLineUp from './ParticipantLineUp';
import SelectLineUp from './SelectLineUp';
import DeleteArea from './DeleteArea';

const Wrapper = styled.article`
    width: 800px;
`;

const TopPanel = styled.header`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
`;

const Content = styled.div`
    position: relative;
`;

const DeleteAreaWrapper = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
`;

function MakerTool() {
    return (
        <Wrapper>
            <TopPanel>
                <SelectLineUp />
            </TopPanel>
            <Content>
                <DeleteAreaWrapper>
                    <DeleteArea />
                </DeleteAreaWrapper>
                <ParticipantLineUp />
            </Content>
        </Wrapper>
    );
}

export default MakerTool;



/** WEBPACK FOOTER **
 ** ../src/dash/front/grid-maker-tool-page/components/MakerTool.js
 **/